export const TW = 'zh-TW'
export const JP = 'ja'
